import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ShieldCheck, FileEarmarkText, ChevronRight } from "react-bootstrap-icons";

// --- SÖZLEŞME İÇERİKLERİ ---
const CONTRACT_CONTENT = {
  "abonelik": {
    title: "Abonelik Sözleşmesi",
    content: (
      <>
        Abonelik Sözleşmesi

        1.Taraflar

        A. Hizmet Sağlayıcı Bilgileri (Sözleşmede “STAİ BİLİŞİM A.Ş” olarak anılacaktır.)

        Hizmet Sağlayıcı : STAİ BİLİŞİM SANAYİ VE TİCARET ANONİM ŞİRKETİ

        Vergi Daire ve Vergi Numarası: Pamukkale Vergi Dairesi / 7811146842

        Şirket Adresi : Sırakapılar Mah,   Saltak Cad., No:58 , İç kapı No: 2, Merkezefendi/Denizli

        e-posta adresi : staibilisim@gmail.com

        İnternet sitesi: www.staibilisim.com

        Üye Bilgileri (Sözleşmede “Üye” olarak anılacaktır.)

        Üyenin Adı ve Soyadı:

        Telefon :

        E-Posta :

        2.Sözleşmenin Konusu, Süresi, Yürürlük tarihi ve Ücreti

        Sözleşmenin konusu, Üye’nin; STAİ BİLİŞİM A.Ş tarafından www.staibilisim.com internet sitesi üzerinden satışa sunulan uygulamaların kullanması ve karşılığında bu maddede belirtilen üyelik ücretini ödemesi ve üyelik sürecinde kullanılan uygulamalara ilişkin teknik desteğin sunulmasından ibarettir.

        Sözleşme yıllık abonelikler için sözleşmenin imzalanmasından itibaren 1 yıl(bir yıl), aylık abonelikler için 1 ay(bir ay) süre ile geçerlidir. Üye’nin talebi doğrultusunda yıllık ve aylık aboneliklerde sözleşme kendiliğinden yenilecektir.

        Bu sözleşme .. / .. / …. tarihinde imzalanmış olup kullanıcı hesabı/hesapları bu tarihte aktif hale getirilmiştir.

        Bu sözleşme bireysel üyelik olarak akdedilmiş ve bu ücretin belirlenmesinde satın alım tarihinde staibilisim.com internet sitesinde yer alan üyelik ücretleri göz önünde bulundurulur.

        3. Tanımlar

        Uygulamalar: staibilisim.com internet sitesi üzerinden satışa sunulan tüm uygulamaları ifade eder.

        Bireysel Üyelik : Mesleki amaçla hareket eden tekil giriş hakkı olan üyeliği ifade eder.

        Hizmet: STAİ BİLİŞİM A.Ş’nin kullanıcılarına sunduğu hizmet ve faydaların tamamını ifade eder.

        Üyelik Ücreti :  Uygulamaların tek bir kullanıcı tarafından tek bir kullanıcı hesabı altında kullanılması karşılığında belirlenmiş olan aylık/yıllık ücreti ifade eder.

        Toplam Kullanım Ücreti:

        Üyelik ücretini veya üyelik ücreti ile ek kullanıcı ücretinin toplamını ifade eder.

        Tekil Giriş: Bireysel üyelik sahibinin hesap sahibi olarak yalnız kendisinin uygulamalara giriş yapabilmesini ifade eder.

        Aydınlatma Metni: www.staibilisim.com sitesinde bulunan aydınlatma metnini ifade eder.

        Kullanım Koşulları: www.staibilisim.com adresinde bulunan kullanım koşullarını ifade eder.

        Üye’nin Beyan, Sorumluluk ve Taahhütleri

        Üye, bu sözleşmenin eki mahiyetinde olan 1- Üye ve Ziyaretçi Aydınlatma Metnini, 2- Kullanım Koşullarını ve 3- İşbu sözleşmedeki koşulları 4-Mesafeli Satış Sözleşmesini okuduğunu, anladığını ve bu koşullarla bağlı olduğunu hem bu koşullara hem de yürürlükte bulunan tüm kanunlara, yönetmeliklere ve sair mevzuata uyacağını açıkça kabul, beyan ve taahhüt eder.

        staibilisim.com sitesinde yer alan tüm yazılımlara ilişkin kaynak kodu, veri kodu ve diğer tüm geliştirmeler 5846 sayılı Fikir ve Sanat Eserleri Kanunu ve diğer mevzuat hükümleri kapsamında kopyalanamaz, çoğaltılamaz, tersine mühendislik yapılamaz, umuma iletilemez, kullanım koşullarında mevcut koşullar dışında bir amaçla kullanılamaz. STAİ BİLİŞİM A.Ş mahkeme ilamları ve ilam niteliğindeki belgelerin açık kaynak olduğunu ve kararlar üzerinde Fikir ve Sanat Eserleri Kanunu kapsamında bir hakkı olmadığını beyan eder. Ancak uygulamaların veritabanı ve kaynak kodlarının  tamamının veya önemli bir bölümünün kopyalanması amacıyla çalıştırıldığını tespit etmesi halinde üyeliği tek taraflı olarak iptal edebilir ve üyenin erişimini durdurabilir.

        Üye, STAİ BİLİŞİM A.Ş ve diğer üyelerine ve üçüncü kişilere ürünün yahut hizmetin istenmeyen iletilerini, reklamlarını veya davetlerini göndermemeyi kabul, beyan ve taahhüt eder.

        Üye, spam, virüs, truva atı ve bunlarla sınırlı olmaksızın benzeri diğer kötü niyetli yazılımlar ile aynı anda çoklu satın alım yapmak gibi staibilisim.com internet sitesi ve uygulamaların çalışmasını durdurucu yahut yavaşlatıcı veya engelleyici iş, işlem veya eylemlerde bulunmayacağını veya bu yönde iş, işlem veya eylemlerde bulunan üçüncü kişilerle herhangi bir ilişki içerisinde olmayacağını kabul, beyan ve taahhüt eder. Bu durumda STAİ BİLİŞİM A.Ş zararını ilgiliden tazmin edecektir.

        Üye, yegâne takdir yetkisi STAİ BİLİŞİM A.Ş’de olmak üzere, staibilisim.com internet sitesi ve uygulamalara erişimin engellenmesine ilişkin mahkeme kararı ve STAİ BİLİŞİM A.Ş’nin kontrolünde olmayan teknik aksaklıklar dâhil olmak üzere mücbir sebeplerle zaman zaman tüm hizmetlere veya hizmetlerin bir kısmına ya da staibilisim.com internet sitesine erişimi tüm üyeler için kısıtlayabileceğini kabul eder.

        Uygulamalara Erişimin Sağlanması

        Üye; Stai Bilişim A.Ş’nin sağladığı hizmetlerin genel itibari ile hatasız olmadığını ve işbu Sözleşme’de  tarafından oluşturulan yazılımlara dair hiçbir beyan ve tekeffül verilmediğini bildiğini kabul ve beyan eder.

        Üyenin uygulamalardan faydalanabilmesi için gerekli olan kullanıcı adı ve şifre kişiye özeldir. Üye kendisine tahsis edilen kullanıcı adı ve şifre ile uygulamaların yalnızca kendisi tarafından kullanılacağını kabul, beyan ve taahhüt eder. Üyenin kullanıcı adı ve şifresinin Üye dışında üçüncü kişilerce kullanıldığının tespit edilmesi halinde, üyelik derhal iptal edilir.

        STAİ BİLİŞİM A.Ş; uygulamaların kullanım şeklini, şartlarını, özelliklerini tek taraflı olarak değiştirebilir.

        Üye; uygulamaların yazılımını ve yapay zekâsını daha iyi bir seviyeye getirmek için çaba gösterdiğini, geliştirmelerinin sona ermediğini ve bu nedenle süreç içinde aksaklıklar yaşanabileceğini bildiğini kabul ve beyan eder.

        Uygulamalarda yaşanabilecek aksaklıklar ve teknik destek için staibilisim@gmail.com adresine mail de gönderilebilir.



        Sözleşmenin Feshi:

        Yıllık abonelik paketi alımında Abonelik Sözleşmeleri Yönetmeliği madde 22 uyarınca, üye sözleşmeyi herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin dilediği zaman feshedebilir. Sözleşmenin herhangi bir nedenle feshedilmesi halinde, fesih bildiriminin hüküm ifade etmesinden itibaren 14 gün içinde Üye tarafından ödenmiş olan Toplam Kullanım Ücreti’nin Üye tarafından kullanılmayan süre için tahsil edilmiş kısmı STAİ BİLİŞİM A.Ş tarafından üyeye iade edilir.

        STAİ BİLİŞİM A.Ş; üyenin sözleşmede belirlenen yükümlülüklerini yerine getirmemesi durumunda üyeye göndereceği bir ihtarname ile ihlalin 7 (yedi gün) içerisinde düzeltilmesini talep eder, söz konusu süre neticesinde ihlalin düzeltilmemesi hâlinde ise dilediği takdirde işbu sözleşmeyi fazlaya dair alacak hakları saklı kalmak, vergi bir ücret iadesi yapmamak ve hiçbir tazminat sorumluluğuna tabi olmaksızın feshetmek hakkına haiz olacaktır.

        Cayma Hakkı

        Üye yıllık abonelik paketi sözleşmesinin sözleşmenin akdedilmesinden itibaren 14 gün içinde Cayma hakkını kullanabilir. STAİ BİLİŞİM A.Ş bu hakkın elektronik ortamda anında ifa edilen hizmetler için geçerli olmadığını ileri sürmeyeceğini kabul beyan ve taahhüt eder. Bu kapsamda uygulamaların kullanıldığı süre deneme süresi olarak kabul edilir.

        Yargı Yetkisi:

        Taraflar arasında iş bu sözleşmeden doğabilecek ihtilafların çözümünde STAİ BİLİŞİM A.Ş merkezinin bulunduğu yer mahkemeleri ve İcra Müdürlükleri yetkilidir. Taraflar arasında bu sözleşme .. / .. / ….. tarihinde imzalanmıştır.


      </>
    )
  },
  "mesafeli-satis": {
    title: "Mesafeli Satış Sözleşmesi",
    content: (
      <>
        1. MESAFELİ SATIŞ SÖZLEŞMESİ

        İşbu Mesafeli Satış Sözleşmesi; STAİ Bilişim Sanayi ve Ticaret Anonim Şirketi ile www.staibilişim.com internet sitesinden ve/veya herhangi bir elektronik ortam üzerinden yıllık yenilenen abonelik seçeneğini seçen ve bu kapsamda şirketimizin çıkardığı uygulamaların sunduğu özelliklerden faydalanmak için işbu sözleşmeyi akdeden tüketici arasında imzalanmaktadır. Sözleşmenin devamında taraflardan STAİ BİLİŞİM A.Ş ve TÜKETİCİ olarak bahsedilecektir.

        İşbu Sözleşme elektronik ortamda satılan hizmetin aşağıda detayları belirtilen koşullar dahilinde Tüketici tarafından satın alınarak ve onaylanarak yürürlüğe girmiştir.

        VERGİ DAİRESİ VE VERGİ NUMARASI: Pamukkale Vergi Dairesi - 7811146842

        ŞİRKET ADRESİ: Sırakapılar Mah., Saltak Cad. No:58 İç Kapı No: 2, Merkezefendi/Denizli

        ŞİRKET e-posta ADRESİ: www.staibilisim.com

        2. Sözleşmenin Konusu

        İşbu Sözleşme’nin konusu, TÜKETİCİ’NİN ödemekle yükümlü olduğu abonelik bedelini STAİ BİLİŞİM A.Ş’YE ödediği süre boyunca TÜKETİCİ’NİN internet üzerinden bağlantı sağlayacağı www.staibilisim.com internet sitesinden sunulan MİRASIM uygulamasından yararlanma şartları (bu kapsamda 6052 sayılı Tüketicinin Korunması Hakkında Kanun, Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanması hakkındadır.

        3. Hizmet Bilgileri Ve Tanımlar

        Tüketici, www.staibilisim.com web sitesi üzerinden ve/veya telefon, ipad ve/veya başkaca teknolojik aletler üzerinden ödeme metodları üzerinden Aylık/Yıllık abonelik şeklindeki hizmetlerimizden yararlanan kişileri ifade eder

        Abonelik Paketleri, STAİ BİLİŞİM A.Ş tarafından sağlanan MİRASIM uygulamasını kullanmak için Tüketici tarafından seçilecek olan abonelik türlerini ifade eder. Buna göre abonelik paketleri staibilisim.com adresinde yıllık olarak kullanıcıya sunulur.

        4. Ödeme Metodlarına İlişkin Abonelikler Hakkında Bilgilendirme

        Tüketici, staibilisim.com adresi üzerinden üyelik başvurusu yaptığı esnada Aylık veya Yıllık Paketlerden birini seçtikten sonra sisteme banka/kredi kartı bilgisi tanıtmakta veya havale ile ödeme yapmaktadır.

        Tüketici ilgili ödeme yöntemleri ile Aylık ve Yıllık seçimlerini kullanabilir. Banka/kredi kartı ile alımlarda abonelik Tüketici tarafından ilk satın alım esnasında tek sefere mahsus olmak üzere tahsil edilecektir. Tüketici isterse, “sonraki dönemlerde aboneliği yenileme” seçeneğini seçerek aboneliğinin her ay otomatik olarak yenilenmesini talep edebilecektir. Yenilenen döneme ilişkin hizmet bedeli Tüketici’nin staibilisim.com sitesinde bildirdiği banka/kredi kartı üzerinden düzenli olarak; ilk kesilen fatura tarihine denk gelen ay dönümünde tahsil edilecektir ve Tüketici tarafından iptal edilmediği sürece devam edecektir.

        5. Paket Değişiklikleri

        Tüketici, abonelik modelleri ve paketler arasında belirli ölçülerde ve belirtilen koşullar doğrultusunda değişiklik yapabilmektedir. Tüketici, paket değişikliği yapmak isterse Banka/Kredi Kartı vermek suretiyle başlatılan aboneliklerdeki paket değişiklerinde, Tüketici tarafından seçilen ilk aboneliğin değiştirilmesi üzerine, ilk başlatılan abonelik paketinden kalan bakiye STAİ BİLİŞİM A.Ş tarafından Tüketici’ye iade edilecek ve yeni paket bedeli Tüketici’den tahsil edilecektir. Havale ile ödemelerde de aynı usul uygulanacaktır.

        6. Hizmet Kullanımına İlişkin Bilgilendirme

        Tüketici, ifa ettiği 5846 sayılı Fikir ve Sanat Eserleri Kanunu’na uygun olarak lisans haklarına sahip olduğu  MİRASIM uygulamasında sunulan diğer hizmetleri hiçbir şekilde ticari amaçlarla kullanmayacağını, işbu Sözleşme’de açıkça belirtilmeyen hiçbir yetkinin kendisine devredilmediğini kabul, beyan ve taahhüt eder. Tüketici tarafından bireysel kullanım dışında ticari amaçla kullanılması halinde Tüketici, bu kullanımın işbu Sözleşme ve hukuka aykırılık teşkil ettiğini kabul eder. STAİ BİLİŞİM A.Ş bu durumda tüm zararını Tüketiciden tahsil etme hakkına sahiptir.

        Tüketici, MİRASIM uygulamasının teknik donanım, yazılım programları, sistemsel altyapı vb. sağlanmasından münhasıran kendi sorumlu olduğunu kabul, beyan ve taahhüt eder. Tüketici’ye ait gerekli altyapı, donanım veya cihazları sağlamaması sonucu  ifa edilmemesinden kaynaklı herhangi bir sorumluluğu bulunmamaktadır. STAİ BİLİŞİM A.Ş; mücbir sebep sayılan veya olası kontrol dışı umulmayan hallerde yükümlülüklerinden herhangi birinin geç veya eksik ifa edilmesi veya ifa etmeme nedeniyle sorumlu olmaz.

        7. Hizmet Bedelleri

        Hizmet bedeli, Tüketici’nin banka veya kredi kartından veya havale yolu ile tahsil edilecek olup aşağıda belirtilen şekillerde Tüketici’den ödeme alınacaktır.

        Banka veya kredi kartıyla yıllık abonelik seçilmesi halinde

        Satın alınan abonelik tek seferlik tahsil edilecek ve Tüketici, yıllık abonelik bedelini ödeyecektir. Satın alınan abonelik Tüketici isterse otomatik olarak yenilenen her yıllık dönem başında tahsil edilecektir. Bu yıllık fiyatlar STAİ Bilişim A.Ş tarafından belirlenen güncel bedeller ve staibilisim.com internet sitesinde yer alan bedeller üzerinden tahsil edilecektir.  Toplam tutar, ŞİRKET tarafından tek seferde peşin olarak tahsil edilecektir.

        8. Hizmetin Teslimi ve Aktivasyona İlişkin Bilgiler

        Tüketici tarafından satın alınan hizmet, elektronik ortamda teslim edilmektedir. Öncelikle staibilisim.com sitesi üzerinden üyelik oluşturulmalıdır. Ardından Tüketici, tahsilatın yapıldığı andan  sonra uygulamadan faydalanmaya başlayabilecektir. Bu aşadan sonra Tüketici, MİRASIM uygulamasına e-mail ve şifresi ile giriş yaparak ulaşabilir.

        Satın alınan ve/veya yenilenen dönemlerde herhangi bir nedenle hizmet bedeli tahsil edilemez veya ödeme iptal edilir yahut teknik bir sebep dolayısıyla ödeme tahsil edilemez ise, STAİ Bilişim A.Ş ilgili döneme ilişkin olarak hizmetin teslimi ve hizmetin sağlanması yükümlülüğünden kurtulmuş kabul edilir.

        Ödemenin kredi kartı vb. ile harcama belgesi düzenlenmeksizin yapıldığı durumlarda, kredi kartının bir başkası tarafından hukuka aykırı şekilde kullanılması hâlinde; 5464 sayılı “Banka Kartları ve Kredi Kartları Kanunu” ve 13/06/2019 tarihli 30800 sayılı Resmi Gazete’de yayımlanan “Banka Kartları Ve Kredi Kartları Hakkında Yönetmelikte Değişiklik Yapılmasına Dair Yönetmelik” ile değişikliğe uğrayan 10/3/2007 tarihli ve 26458 sayılı Resmî Gazete’de yayımlanan “Banka Kartları ve Kredi Kartları Hakkında Yönetmelik” hükümlerine göre işlem yapılacaktır.

        9. Abonelik İptali Ve Cayma Hakkı Hakkında Bilgilendirme

        Aylık Yenilenen Abonelik seçilmesi halinde; abonelik iptalini yenileme dönemi öncesindeki bir ay içerisinde mail adresine iletilmesi suretiyle gerçekleştirilebilir. İptal talebinin alınması üzerine, bir sonraki ay içerisinde yenileme tarihine denk gelen günde abonelik otomatik olarak durdurulacaktır. Tüketici; hizmet bedelini ödediği ve uygulamadan yararlanmaya başladığı aya ve yıla ilişkin olarak STAİ BİLİŞİM A.Ş’den hizmet bedeli iadesi talebinde bulunamayacaktır.

        Mesafeli Satış Yönetmeliği’nin 15. Maddesinin ğ fıkrası hükümleri uyarınca Tüketici tarafından cayma hakkının kullanılması mümkün değilse de Tüketici “yıllık” abonelik paketi sözleşmesinin sözleşmenin akdedilmesinden itibaren 14 gün içinde Cayma hakkını kullanabilir. STAİ BİLİŞİM A.Ş bu hakkın yıllık aboneliklerde elektronik ortamda anında ifa edilen hizmetler için geçerli olmadığını ileri sürmeyeceğini kabul beyan ve taahhüt eder. Bu kapsamda uygulamanın kullanıldığı süre deneme süresi olarak kabul edilir.

        Tüketici, ödeme işlemlerini kredi kartı ile yaptığı durumda temerrüde düştüğü takdirde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde bankaya karşı sorumlu olacağını kabul, beyan ve taahhüt eder.

        STAİ BİLİŞİM A.Ş, koruma önlemlerini hizmet kalitesinin arttırılması ve/veya Tüketicilere sunduğu hizmet kapsamındaki içeriklerin hukuka aykırı kullanımını engelleme ve/veya yetkisiz 3. kişiler tarafından güvenli ve yasal olmayan yöntemlerle içeriklere erişimi engelleme amacıyla gerekli görüldüğünde değiştirilebilmektedir.

        10. Tüketici Şikayetleri Ve Uyuşmazlık Çözümü

        Tüketici, hizmetlere ilişkin şikayetlerini www.staibilisim.com adresi üzerinden ve staibilisim@gmail.com mail adresi üzerinden iletebilir. Bununla birlikte tüketici şikâyet ve itiraz başvuruları, Bakanlıkça her yıl Aralık ayında belirlenen parasal sınırlar dâhilinde, Tüketici’nin ikametgâhının bulunduğu yerdeki Tüketici Sorunları Hakem Heyetine veya tüketicinin ikametgahında bulunan Tüketici Mahkemesine yapılabilecektir.
      </>
    )
  },
  "gizlilik": {
    title: "Gizlilik ve Çerez Politikası",
    content: (
      <>
        GİZLİLİK POLİTİKASI



        GİZLİLİK VE ÇEREZ POLİTİKASI

        STAİ BİLİŞİM SANAYİ VE TİCARET ANONİM ŞİRKETİ olarak gizliliğinize ve güvenliğinize önem vermekteyiz. Bu kapsamda kullanıcı deneyiminizi geliştirmek, www.staibilisim.com internet sitemizden en iyi şekilde faydalanmanızı sağlamak ve KVKK Aydınlatma metninde yazılı amaçlarımızla sınırlı olarak çerezler kullanmaktayız. www.staibilisim.com internet sitemizi kullandığınız sürece Gizlilik ve Çerez Politikası’nı kabul etmiş sayılırsınız. Bu kapsamda bilgisayarınıza ya da mobil cihazınıza bu metinde yer alan çerezlerin yerleştirilmesine onay verdiğiniz kabul edilir. Bu metinde çerezin ne olduğu, bilgisayarınıza yerleştirilen çerezleri ve amaçları, çerezleri nasıl silebileceğiniz konularında detaylı bilgi yer almakta olup bu metin; sizleri bu konularda bilgilendirmek amacıyla hazırlanmıştır. Bu nedenle; Gizlilik ve Çerez Politikası’nı dikkatlice okumanızı öneriyoruz.



        1) Çerez (Cookie) Nedir?

        Çerez, kullanıcı deneyiminizi artırmak, KVKK Aydınlatma Metni’nde yer alan veri işleme amaçlarımızı gerçekleştirmek ve güvenliğinizi sağlamak amacıyla bilgisayarınıza ya da mobil cihazınıza yerleştirdiğimiz elektronik metin dosyasıdır. Tarayıcınıza yerleştirilen çerezler bilgisayarınızdaki ya da mobil cihazınızdaki hiçbir bilgiye erişim imkânı tanımaz ve şahsi bilgilerinizin güvenliğini tehlikeye düşürmez.

        2) Çerezlerin Yerleştirilmesi ve Çerez Tercihinizi Değiştirmek

        İnternet tarayıcıları genellikle çerezleri otomatik olarak kaydedecek şekilde kullanımınıza sunulur. Bu sebeple çerezler, kullandığınız internet tarayıcısı tarafından otomatik kabul edilebilir. Çerezlerin kaydedilmesini istemediğiniz ya da silmek istediğiniz takdirde kullandığınız tarayıcının ayarlarından bu tercihinizi size sunulan diğer tercihlerle değiştirebilirsiniz. Çerezler, internet sitemizdeki kişisel tercihlerinizin hatırlanmasını sağlayarak uygulamalarımızdan en iyi şekilde faydalanmanızı sağlar. Çerezleri engellediğinizde, sildiğinizde veya çerez yerleştirme tercihinizi değiştirdiğinizde internet sitemizi ya da bazı özellikleri kullanamayabilirsiniz. Çerezler size ait bir veri olup internet sitemize kullanıcı girişi yapılmadığında tarayıcınız tarafından anonim olarak işlenebilir. Çerezler tarayıcınız tarafından tutulduğundan www.staibilisim.com  internet sitesinin kaydedilen çerezleri yönetme, değiştirme ya da silme yetkisi bulunmamaktadır. Bu sebeple çerezler bakımından www.staibilisim.com internet sitesi veri sorumlusu sıfatına sahip değildir.

        Aşağıdaki yöntemleri kullanarak çerezlere izin verme ve reddetme imkanını kullanabilirsiniz:

        • Google Chrome​: Tarayıcınızın adres bölümünde yer alan, "kilit işareti"ni tıklayarak, "çerezler" sekmesinden çerezlere izin verebilir veya engelleyebilirsiniz.
        • Mozilla Firefox​: Tarayıcınızın sağ üst köşesinde yer alan "menüyü aç" sekmesini tıklayınız. "Seçenekler" görselini tıklayarak "Gizlilik ve Güvenlik" butonunu kullanarak çerezleri yönetebilirsiniz.
        • Opera​: Tarayıcınızın "Tercihler" bölümünde "Gelişmiş"i seçerek "çerezler" bölümünden çerez yönetimini yapabilirsiniz.
        • Safari​:Telefonunuzun "Ayarlar" bölümünden "safari" sekmesini seçip, "Gizlilik ve Güvenlik" Bölümünden tüm çerez yönetiminizi yapabilirsiniz.
        Yukarıdaki seçeneklerin yanı sıra; tüm çerezler hakkında bilgi sahibi olmak ve çerez yönetimi için: https://www.allaboutcookies.org, https://www.youronlinechoices.eu/ adresini ziyaret edebilirsiniz, veya "Privacy Badger" uygulamasını kullanabilirsiniz (https://www.eff.org/tr/privacybadger). Kalıcı çerezleri veya oturum çerezlerini reddederseniz, web sitesini, mobil uygulamayı ve mobil sitesini kullanmaya devam edebilirsiniz fakat web sitesinin, mobil uygulamanın ve mobil sitesinin tüm işlevlerine erişemeyebilirsiniz veya erişiminiz sınırlı olabilir.



        3) Çerez Türleri - Çeşitleri Nelerdir ve Çerezleri Neden Kullanıyoruz?

        Çerezler, geçici ve zorunlu çerezler şeklinde kategorize edilmektedir. Her iki çerez türü internet sitemize eriştiğinizde tarayıcınız tarafından oluşturulur ve tarayıcınızda depolanır.

        Çerez Türleri;

        Geçici çerezler; İnternet sitemize eriştiğiniz anda tarayıcınız tarafından oluşturulur ve depolanır. İnternet sitemizden ayrıldığınızda tarayıcınız tarafından silinir.

        Zorunlu çerezler; İnternet sitemize eriştiğiniz anda tarayıcınız tarafından oluşturulur ve çerez tercihlerinizi değiştirmediğiniz sürece tarayıcınızda depolanmaya devam eder.

        Zorunlu çerezler, internet sitemizi kullanmanız için gerekli kalıcı çerezlerdir. Bu çerezler sayesinde internet sitemizdeki kayıtlı kullanıcı oturumunuz ve kullanıcı ayarlarınız hatırlanmaya devam eder. Bu çerezleri sildiğinizde ise kullanıcı bilgileriniz hatırlanmayacağından internet sitemizde yalnızca kayıtlı kullanıcılara sunulan alanları ve bölümleri kullanamazsınız. Zorunlu çerezler sadece kullanıcı bilgilerinin hatırlanması, oturumun devamını sağlamak, güvenlik ve kullanıcı bilgilerini doğrulamak amacıyla kullanılır. Zorunlu çerezler reklam, pazarlama ya da benzeri başkaca meşru bir amaç için kullanılmaz.

        Çerez Çeşitleri;

        Kişiselleştirme İçin Gerekli Olan Çerezler:

        Bu çerezler, kullanıcıların www.staibilisim.com internet sitesindeki kişiselleştirilmiş tercihlerinin hatırlanmasını sağlamak amacıyla kullanılır. Bu çerezler sayesinde kullanıcılar kişisel ayarlarını ve tercihlerini kullanabileceğinden; bu çerezlerin silinmesi durumunda kullanıcıların tercihleri hatırlanmayacağından kullanıcılar kişiselleştirilmiş bir kullanıcı deneyimine sahip olamazlar.

        Reklam ve Pazarlama İçin Gerekli Olan Çerezler:

        Bu çerezler, kullanıcıların kişisel tercihlerinin ve davranışlarının hatırlanması suretiyle kullanıcılara özel reklam gösterimini sağlamak amacıyla kullanılır. Bu çerezler sayesinde kullanıcılara kişiselleştirilmiş mal ve hizmet reklamı sunulur ve bu reklamlar sınırlandırılır. Ayrıca reklam ve pazarlama etkinliklerinin başarısı derecelendirilir.

        Gizlilik ve Çerez Politikası’na İlişkin Değişiklikler ve Son Hükümler

        Gizlilik ve Çerez Politikası 6698 Sayılı Kişisel Verilerin Korunması Kanunu ile ikincil mevzuat hükümleri kapsamında düzenlenmiştir. İşbu politika, internet sitemizde yer alan KVKK Aydınlatma Metni ile Kullanıcı Sözleşmesi’ne uygun olarak hazırlanmıştır. Gizlilik ve Çerez Politikası; KVKK Aydınlatma Metni’nin eki niteliğinde olup bu metinde yazılı olmayan hususlar bakımından KVKK Aydınlatma Metni hükümleri geçerlidir. www.staibilisim.com internet sitesi Politika’yı gerekli gördüğü zaman değiştirme hakkına sahiptir. Metnin güncel haline www.staibilisim.com internet sitemizdeki ilgili alandan ulaşabilirsiniz. İşbu metne ilişkin talep ve sorularınız için
      </>
    )
  },
  "iptal-iade": {
    title: "Teslimat ve İade Koşulları",
    content: (
      <>
        Teslimat ve İade Şartları

        Kullanmakta olduğunuz uygulamalarla ilgili olarak staibilisim.com internet sitesi üzerinden elektronik ortamda abonelik paket satın alımı gerçekleştirdiğiniz takdirde, size sunulan Abonelik Sözleşmesini ve Mesafeli Satış Sözleşmesini kabul etmiş sayılırsınız. Üyeler, satın aldıkları abonelik satış ve teslimi ile ilgili olarak 6502 sayılı Üyenin Korunması Hakkında Kanun, Mesafeli Sözleşmeler Yönetmeliği, Abonelik Sözleşmeleri Yönetmeliği hükümleri ile yürürlükteki diğer yasalara tabidir.

        Satın alınan her bir abonelik, aynı anda kullanıma açılır. Satın alınan abonelik, sitemizde belirtilen niteliklere uygun olarak kullanıma sunulur. Satın alınan aboneliğin yapılacak geliştirmeler yahut bakım, onarım kontrol ve benzeri nedenlerle internet sitemiz ve uygulamalara erişimin sağlanamayacağı ve hizmetin aksayacağına yönelik bilgilendirme üyenin, üyelik için kullandığı e-posta adresine yapılır. Aboneliğin satılmasının imkansızlaşması durumunda, şirketimiz bu durumu Üye’ye bildirmek ve 14 gün içinde toplam bedel Üye’ye iade edilmek zorundadır.

        Satın Alınan Abonelik Bedeli Ödenmezse:

        Üye, satın aldığı abonelik bedelini ödemez veya banka kayıtlarında iptal ederse STAİ BİLİŞİM A.Ş’nin abonelik kullanıma sunma yükümlülüğü sona erer.

        Kredi Kartının Yetkisiz Kullanımı ile Yapılan Alışverişler:

        Ödemenin kredi kartı vb. ile harcama belgesi düzenlenmeksizin yapıldığı durumlarda, kredi kartının bir başkası tarafından hukuka aykırı şekilde kullanılması hâlinde; 5464 sayılı “Banka Kartları ve Kredi Kartları Kanunu” ve 13/06/2019 tarihli 30800 sayılı Resmi Gazete’de yayımlanan “Banka Kartları Ve Kredi Kartları Hakkında Yönetmelikte Değişiklik Yapılmasına Dair Yönetmelik” ile değişikliğe uğrayan 10/3/2007 tarihli ve 26458 sayılı Resmî Gazete’de yayımlanan “Banka Kartları ve Kredi Kartları Hakkında Yönetmelik” hükümlerine göre işlem yapılacaktır.

        Öngörülemeyen Sebeplerle Abonelik Süresinde Teslim Edilemez ise:

        Üye, teknik donanım, yazılım programları, sistemsel altyapı vb. sağlanmasından münhasıran kendi sorumlu olduğunu kabul, beyan ve taahhüt eder. STAİ BİLİŞİM A.Ş’nin; Üye’ye ait gerekli altyapı, donanım veya cihazları sağlamaması sonucu ifa edilmemesinden kaynaklı herhangi bir sorumluluğu bulunmamaktadır. Mücbir sebep sayılan veya kontrol dışı umulmayan hallerde STAİ BİLİŞİM A.Ş yükümlülüklerinden herhangi birini geç veya eksik ifa etme veya ifa etmeme nedeniyle sorumlu olmaz.

        İptal ve Cayma Hakkı:

        Üye; hizmet bedelini ödediği ve MİRASIM uygulamasından yararlanmaya başladığı aya ve yıla ilişkin olarak STAİ BİLİŞİM A.Ş’den hizmet bedeli iadesi talebinde bulunamayacaktır. Mesafeli Satış Yönetmeliği’nin 15. Maddesinin ğ fıkrası hükümleri uyarınca Üye tarafından cayma hakkının kullanılması mümkün değilse de Üye “yıllık” abonelik paketi sözleşmesinin sözleşmenin akdedilmesinden itibaren 14 gün içinde Cayma hakkını kullanabilir. STAİ BİLİŞİM A.Ş bu hakkın yıllık aboneliklerde elektronik ortamda anında ifa edilen hizmetler için geçerli olmadığını ileri sürmeyeceğini kabul beyan ve taahhüt eder. Bu kapsamda bu süre deneme süresi olarak kabul edilir.

        Temerrüt Hali ve Hukuki Sonuçları:

        Üye, ödeme işlemlerini kredi kartı ile yaptığı durumda temerrüde düştüğü takdirde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde bankaya karşı sorumlu olacağını kabul, beyan ve taahhüt eder.</>
    )
  },
  "kvkk": {
    title: "KVKK Aydınlatma Metni",
    content: (
      <>

        {/* --- BURAYA YAPIŞTIRIN (KVKK METNİ GELECEK) --- */}
        {/* Aşağıdaki p etiketini silip kendi metnini buraya koyabilirsin */}

        <p>                          KVKK KAPSAMINDA KULLANICI VE ZİYARETÇİ AYDINLATMA METNİ

          STAİ Bilişim Sanayi ve Ticaret Anonim Şirketi (STAİ BİLİŞİM A.Ş ) tarafından veri güvenliğinize önem verilmektedir. Bu sebeple işbu “Kullanıcı ve Ziyaretçi Aydınlatma Metni” ile sizi 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca  veri sorumlusu sıfatıyla STAİ Bilişim Sanayi Ticaret Anonim Şirketi tarafından hazırlanmıştır. İşbu metnin devamında veri sorumlusundan STAİ BİLİŞİM A.Ş olarak bahsedilecektir.

          Bu aydınlatma metni, “staibilisim.com” internet sitesi ve  mobil uygulama üzerinden verilen hizmete başvuran, abone olan, kullanan, üye olan, ziyaret eden, üçüncü kişiler vasıtasıyla veya STAİ BİLİŞİM A.Ş  aracılığıyla ya da  iştiraklerinden alınan her türlü hizmeti satın alınan, erişen, öneri, destek, başvuru, bilgi, kullanım, şikâyet talepleri için herhangi bir iletişim aracılığıyla iletişime geçen kişilerin kişisel verilerin toplanması, korunması, işlenmesi, işlenen verilerin güvenli bir şekilde barındırılması ve hukuka aykırı biçimde kullanılmasının önlenmesi için gerekli güvenlik tedbirlerinin alındığının bilgisinin verilmesi için tarafınızı aydınlatmak için hazırlanmıştır.

          Önemle belirtmek gerekir ki, kural olarak açık rızanın alınmasının gerektirdiği hallerde tarafınızdan mutlaka açık rıza alınmaktadır; ancak KVKK kapsamında izin verilen istisnai hallerde açık rızanız olmaksızın da kişisel verileriniz işlenebilmektedir. Kişisel verilerinizin korunmasına yönelik politikamıza ise “staibilisim.com” sayfamızı ziyaret ederek ulaşabilirsiniz.

          Kişisel Verilerinizi İşleme Sürecindeki Temel İlkelerimiz ve Önceliklerimiz

          Kişisel verilerinizi 6698 sayılı "Kişisel Verilerin Korunması Kanunu" ile 5651 sayılı "İnternet Ortamında Yapılan Yayınların Düzenlenmesi Ve Bu Yayınlar Yoluyla İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun" kapsamında öngörülen usul ve esaslara uygun şekilde işleyerek korumaktayız. Kanun kapsamındaki "kişisel veri" ifadesinin yalnızca gerçek kişilere ait olan verileri kapsadığını, tüzel kişilere ait "kişisel veri" tanımlamasının olmadığını ayrıca bildirmek isteriz.

          Kişisel verilerinizi; hukuka ve dürüstlük kurallarına uygun, doğru bir şekilde ve güncel olarak, belirli, açık ve meşru amaçlarımız doğrultusunda işlemekteyiz. Ayrıca kişisel verilerinizi; işlediğimiz amaçlarla bağlantılı, sınırlı ve ölçülü şekilde ilgili mevzuatta öngörülen veya işlediğimiz amaç için gereken süre kadar muhafaza etmekteyiz.

          Aydınlatma yükümlülüğümüz kapsamındaki kişisel verileriniz, tamamen veya kısmen otomatik yollarla veya veri kayıt sisteminin parçası olarak otomatik olmayan yöntemlerle işlenmektedir.

          İşbu aydınlatma metninde yazılı kişisel veri işleme amacımız değiştiğinde veri işleme faaliyetine başlamadan önce aydınlatma metnini güncelleyerek bilgilendirme yükümlülüğümüzü yerine getireceğiz.

          1. Tanımlar

          Okumakta olduğunuz Aydınlatma Metninde ve Kanun'da yer alan teknik terimleri daha anlaşılabilir kılmak adına 6698 sayılı Kanun'a uygun, açık ve sade şekliyle aşağıda sıraladık:

          Kişisel veri: Kimliği belirli olan veya belirlenebilir gerçek kişiye ait her türlü bilgiyi,

          Özel nitelikli kişisel veri: Kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik verilerini,



          Veri sorumlusu: Kişisel verilerinizi işleyen, veri işleme amaçlarını ve yöntemlerini belirleyen, verilerinizi korumak üzere kurulan veri kayıt sistemi altyapısını hazırlayan ve yöneten sorumluyu,

          Veri sorumlusu temsilcisi: Türkiye'de yerleşik olmayan veri sorumlularını Kanun'da belirlenen şartlarla temsile yetkili Türkiye'de yerleşik tüzel kişi ya da Türkiye Cumhuriyeti vatandaşı gerçek kişiyi,

          Veri kayıt sistemi: Kişisel verilerin belirli kriterlere göre yapılandırılarak işlendiği kayıt sistemini, Kanun: 6698 Sayılı Kişisel Verilerin Korunması Kanunu'nu,

          Kişisel verilerin silinmesi: Kişisel verilerin ilgili kullanıcılar için hiçbir şekilde erişilemez ve tekrar kullanılamaz hale getirilmesi işlemini,

          Kişisel verilerin yok edilmesi: Kişisel verilerin hiç kimse tarafından hiçbir şekilde erişilemez, geri getirilemez ve tekrar kullanılamaz hale getirilmesi işlemini,

          Kişisel verilerin anonim hale getirilmesi: Kişisel verilerin başka verilerle eşleştirilse dahi hiçbir surette kimliği belirli veya belirlenebilir bir gerçek kişiyle ilişkilendirilemeyecek hale getirilmesi işlemini, ifade eder.

          2. Kişisel Verilerin Toplanması

          Yöntemler:

          • Kişisel verileriniz, yukarıda belirtilen amaçlarla sınırlı olarak açık rıza olmadan veri işlemenin mümkün olmadığı hallerde açık rıza alınarak diğer hallerde açık rıza aranmaksızın sözlü, yazılı ve/veya elektronik ortamda otomatik ve/veya otomatik olmayan yöntemlerle toplanmaktadır.
          • “staibilisim.com” internet sitesi, ileride kurulabilecek diğer internet siteleri ya da STAİ BİLİŞİM A.Ş  adına faaliyet gösteren sosyal medya hesapları üzerinden her türlü abonelik hizmeti, ürün satın alınması, üye olunması ve/veya her türlü form aracılığıyla bilgi doldurulması vasıtasıyla
          • E-posta adresleri, kısa mesajlar, application mesajları, bildirimler vs. vasıtasıyla yapılan başvuru, alım talebi, şikâyet, öneri, talep, istek, destek vs. her türlü belge ve kayıt doldurulması, iletilmesi vasıtasıyla
          • STAİ BİLİŞİM A.Ş  bünyesinde ya da bünyesinde olmaksızın üçüncü kişiler tarafından satış ve pazarlama kapsamında ilgili çalışanla, çağrı merkezi vasıtasıyla,
          • İmzalanan, fiziki teslim edilen, her türlü iletilen sözleşme, belge, evraklar vasıtasıyla
          • Hizmet verilen ya da hizmet alınan kişiler, şirketler, iş ortakları, tedarikçiler, bankacılık işlemleri, mobil bankacılık uygulamaları vs. vasıtasıyla,
          • Ayrıca alenileştirdiğiniz kişisel verilerin amaca uygun olarak ve mevzuatta belirlenen sınırlar dahilinde sözlü veya elektronik olarak işlemekteyiz.
          İşlenen Kişisel Veriler:

          Uygulamalarımıza erişiminizi ve kullanımınızı doğrudan ya da çalıştığınız / bağlı olduğunuz kuruluştan alıyorsanız topladığımız kişisel bilgiler şu şekildedir;

          • Adınız soyadınız, doğum yılı ay ve gün bilgileriniz, e-posta adresiniz, iş yeri adresiniz, fatura adresiniz, posta adresiniz, imzanız, sosyal medya ve telefon numaranız gibi iletişim bilgileriniz,
          • Kullanıcı adları ve parolalar, parola ipuçları ve benzeri güvenlik bilgileri gibi hesap oturum açma bilgileriniz,
          • Mesleki bilgileriniz, sicil numaranız, kayıtlı olduğunuz baro isim bilginiz, kampanya kodları, eğitim ve mesleki geçmiş, nitelikler ve fotoğraf gibi diğer hesap kaydı ve profil bilgileriniz,
          • Müşteri desteğine gönderdiğiniz bilgiler dahil olmak üzere bize sağladığınız yorumlar, sorular, geri bildirimler ve diğer bilgiler ve/veya internet sitesini kullanırken kişiselleştirdiğiniz ilgi alanları, tercih ettiğiniz dil, iletişim tercihleriniz gibi internet sitesinde sizin inisiyatifinize bırakılan alanlardaki seçimlere ilişkin bilgiler,
          • Hizmet aboneliği olan bir kuruluşun yöneticisiyseniz, kuruluşunuzun aboneliği ve ilgili hizmetler hakkında sizinle iletişim kurmak için verilen bilgiler.
          Yukarıdaki hususlara ek olarak tarafınızdan doğrudan topladığımız kişiler bilgileriniz şu şekildedir;

          • Hukuki işlem bilgileri, Noter onaylı belgeler, dava dosyası bilgileri, adli idari düzenleyici kuruşlarla paylaşılan bilgiler
          • Çağrı merkezi ses kayıtları, çağrı merkezi konuşma kayıtları vs. çağrı merkezi ile iletişime geçilirken kullanılan talep ve şikâyet bilgileriniz.
          • Kredi veya banka kartı numarası gibi ödeme bilgileri, ürün veya hizmet satın alma geçmişiniz, banka hesap numarası ve IBAN numarası, buna bağlı olarak isteğiniz doğrultusunda (örn. Faturaya eklenmesi talebi vs.) T.C. Kimlik Numarası, Vergi Kimlik Numarası bilgilerinizdir.
          3. Kişisel İşlenme Amaçları

          KVKK ve ilgili diğer sair mevzuat uyarınca hukuka uygun ve dürüstlük kuralının öngördüğü biçimde, işlenme amaçları ile bağlantılı, sınırlı ve ölçülü olarak, doğru, güncel, belirli, açık ve meşru amaçlar gereği işlenmektedir.

          Aşağıdaki hallerden en az birinin bulunması durumunda kişisel verilerin işlenmesi mümkündür.

          • Açık rızanın alınması halinde
          • Kanunlarda açıkça öngörülmesi,
          • Fiili imkânsızlık nedeniyle rızasını açıklayamayacak durumda bulunan veya rızasına hukuki geçerlilik tanınmayan kişinin kendisinin ya da bir başkasının hayatı veya beden bütünlüğünün korunması için zorunlu olması,
          • Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması,
          • Veri sorumlusunun hukuki yükümlülüğünü yerine getireliilmesi için zorunlu olması,
          • İlgili kişinin kendisi tarafından alenileştirilmiş olması,
          • Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,
          • İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması


          Kişisel verilerinizi işleme amaçlarımız ise şu şekildedir

          • Abonelerin, kullanıcıların, üyelerin, ziyaretçilerin, kurumsal abonelerin verilen hizmeti ifa edebileceği internet sitesine erişiminin ve bu erişime ilişkin güvenliğin sağlanabilmesi,
          • “staibilisim.com” internet sitesi, ileride kurulabilecek diğer internet siteleri ya da STAİ BİLİŞİM A.Ş  adına faaliyet gösteren sosyal medya hesaplarının güvenliğinin sağlanması,
          • Hizmeti ve diğer ürünlerimizin, etkinliklerimizin ve hizmetlerimizin geliştirilmesi, iyileştirmesi ve yeni ürünler, hizmetler, avantajlar ve hizmet modellerinin oluşturulması,
          • Ar-Ge aşamasındaki uygulamaların geliştirilmesi ve bu ürünün pazarlanması,
          • Mobil uygulama, internet sitesi gibi kanallara daha iyi erişebilmenizi sağlamak için teknik sorunlara müdahale etmek, girişi kolaylaştırmak, daha iyi bir kullanıcı deneyimi sunulması,
          • Hizmet kalitesinin artırılması ve hizmet kontrolü sağlanması, hizmet ve diğer ürün ve hizmetlerimizle ilgili değişiklikler, güncellemeler ve diğer duyurular hakkında bilgi verilmesi,
          • Hizmet ve ilgi alanlarınızla ilgili hedefli reklamlar, promosyon mesajları, bildirimler ve diğer bilgilerin sunulması, STAİ BİLİŞİM A.Ş ’nin, iştiraklerin ve sponsorlar gibi üçüncü tarafların ürünleri, etkinlikleri ve hizmetleri hakkında size promosyon mesajları ve diğer bilgilerin sağlanması,
          • Kullanıcı testleri ve anketlerinin yanı sıra çizimlere, çekilişlere, yarışmalara ve benzer promosyonlara katılıma davet etme,
          • Mali ve finansal yükümlülüklerin yerine getirilmesi,
          • Hukuki süreçlerin takibinin yapılması, yetkili kişi, kurum ve kurulara bilgi sağlanması, mevzuattan ve sözleşmeden kaynaklanan yükümlülüklerin yerine getirilmesi,
          • İş faaliyetlerinin yürütülmesi, ortaklarıyla veri paylaşılmasının zorunlu olması, iş süreçlerinin iyileştirilmesine ilişkin süreçlerin takibi,
          • STAİ BİLİŞİM A.Ş’nin şirket içi güvenliğinin sağlanması, risk yönetiminin yapılması, iç denetimlerin gerçekleştirilmesi, etik faaliyetlerin yürütülmesi,
          • İlgi alanlarınız ve coğrafyanızla ürünlerin daha alakalı hale getirilmesi için özelleştirilmiş içerik ve diğer kişiselleştirmelerin sunulması, kişiye özel içerik sağlanması, internet reklamcılığı, kampanya, çapraz satış gibi kişiye özel ürün ve hizmetlere yönelik fırsatların sunulması,
          • E-posta doğrulama işlemlerinin gerçekleştirilebilmesi,
          • Hediye, promosyon vs. gönderilmesi,
          • Kayıt, belge ve evrakların düzenlenmesi, saklanması, arşivlenmesi süreçlerinin gerçekleştirilmesi,
          • Talep, şikâyet, öneri, destek süreçlerinin takibi, karşılanması, yönetilmesi
          • Talep, şikâyet, öneri, destek süreçlerinin takibi, karşılanması, yönetilmesi
          • Satış ve sair pazarlama ve müşteri ilişkileri yönetimi, hizmet memnuniyeti çalışmalarının yürütülmesi,
          • E-posta (ürün ve hizmet reklamları gibi) gönderilmesi,
          • Pazarlama analiz çalışmaları, satış ve piyasa yorumlama, yönetimsel analizler, site kullanımının yorumlanması, istatistiki verilerin hazırlanması, takibi, yürütülmesi


          4. Kişisel Verilerin Aktarılması

          STAİ BİLİŞİM A.Ş , hukuka uygun olan kişisel veri işleme amaçları doğrultusunda, gerekli güvenlik önlemlerini alarak ilgili kişinin kişisel verilerini ve özel nitelikli kişisel verilerini belirtilen amaçlar doğrultusunda yurt içi veya yurt dışındaki üçüncü kişilere aktarabilmektedir. KVKK yer alan açıklanmış olan veri işleme şartlarından en az birinin varlığı halinde ve veri işleme şartlarına ilişkin temel ilkelere uymak şartıyla amaçlarla sınırlı olmak üzere kişisel verileriniz STAİ BİLİŞİM A.Ş  tarafından aktarılabilmektedir.

          Kanunun genel ilkeleri ile ilgili maddelerinde yer alan veri işleme şartları dahilinde

          STAİ BİLİŞİM A.Ş  kişisel verileri, iş ortakları, hizmet aldıkları, tedarikçiler, bankalar, danışmanlık alınan hizmet firmaları ile tarafınıza verilen hizmetin gerçekleştirilmesini yerine getirilmesini temin etmek, depolama hizmeti almak, (Amazon, Google, iCloud vs. bulut hizmetleri) sunucu, hosting hizmeti almak, güvenlik önlemleri almak, pazarlama faaliyeti için geçilen iletişimde çeşitli kanalları kullanmak, alım satıma ilişkin finansal süreçleri yönetmek, server hizmeti almak amaçlarıyla yukarıda belirlenen amaçlar dahilinde aktarımın gerekli olduğu durumlarla sınırlı olarak; yurtiçinde ve yurtdışında bulunan üçüncü kişilere aktarılabilmektedir.

          STAİ BİLİŞİM A.Ş  kişisel verileri ortakları ile, ticari faaliyetlerine ilişkin strateji, hukuki süreç takibi, iş geliştirme, analiz ve denetim amaçlarıyla sınırlı olarak; yurtiçinde ve yurtdışında bulunan üçüncü kişilere aktarılabilmektedir.

          STAİ BİLİŞİM A.Ş  kişisel verileri yetkili kamu kurum ve kuruluşları ile ilgili kamu kurum ve kuruluşlarının bilgi talep etmesi durumunda bu amaçla sınırlı olarak yurtiçinde ve yurtdışında bulunan üçüncü kişilere aktarılabilmektedir. STAİ BİLİŞİM A.Ş  kişisel verileri, yetkili özel hukuk kişileri ilgili özel hukuk kişilerinin hukuki yetkisi dahilinde talep ettiği amaçla sınırlı olarak yurtiçinde ve yurtdışında bulunan üçüncü kişilere aktarılabilmektedir.

          STAİ BİLİŞİM A.Ş , bu doğrultuda KVK Kanunu’nun öngörülen düzenlemelerine uygun hareket etmektedir. STAİ BİLİŞİM A.Ş  tarafından kişisel veriler; KVK Kurulu tarafından yeterli korumaya sahip olduğu ilan edilen yabancı ülkelere veya yeterli korumanın bulunmaması durumunda Türkiye’deki ve ilgili yabancı ülkedeki veri sorumlularının yeterli bir korumayı yazılı olarak taahhüt ettiği ve KVK Kurulu’nun izninin bulunduğu yabancı ülkelere aktarılmaktadır.

          KVKK Uyarınca Sahip Olduğunuz Haklar:

          KVKK 11. maddesi uyarınca sahip olduğunuz haklar şu şekildedir:

          Kişisel verilerinizin tarafımızca işlenip işlenmediğini öğrenebilirsiniz,

          Eğer kişisel verileriniz bizim tarafımızdan işlenmişse bizden buna ilişkin bilgi talep edebilirsiniz

          Kişisel verilerinizi hangi amaçlar için işlediğimizi ve kişisel verilerinizin bu amaçlara uygun şekilde kullanılıp kullanılmadığını öğrenebilirsiniz,

          Kişisel verilerinizi yurt içinde veya yurt dışında aktarılıyorsa, aktarılan üçüncü kişileri öğrenebilirsiniz,

          Eğer kişisel verilerinizi eksik veya yanlış işlemişsek, bunların düzeltilmesini isteyebilir ve gerçekleştirilen bu düzeltmelerin kişisel verilerinizi aktarmış olduğumuz üçüncü taraflara da iletilmesini isteyebilirsiniz.

          Kişisel verilerinizi Kanun’a ve ilgili diğer ulusal ve uluslararası mevzuat hükümlerine uygun olarak işlemiş olmamıza rağmen, kişisel verilerinizin işlenmesini gerektiren sebeplerin ortadan kalkması halinde kişisel verilerinizin silinmesini veya yok edilmesini isteyebilir ve bu kapsamda yapılan düzeltmelerin kişisel verilerinizi aktarmış olduğumuz üçüncü taraflara da iletilmesini isteyebilirsiniz.

          İşlediğimiz verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkması durumunda, meydana gelen bu sonuca itiraz edebilirsiniz,

          İşlediğimiz verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkması durumunda, meydana gelen bu sonuca itiraz edebilirsiniz.

          Yukarıda saymış olduğumuz haklarınızı kolayca kullanabilmeniz ve ilgili talepleri tarafımıza kolayca iletebilmeniz amacıyla bize “staibilisim.com” adresinden veya uygulama içi Geri Bildirim ve İletişim butonu aracılığıyla ulaşabilirsiniz. Size, başvurunuzun niteliğine göre en kısa sürede ve en geç otuz gün içinde cevap vereceğiz.



        </p>


      </>
    )
  }
};

const Sozlesmeler = () => {
  const { type } = useParams();

  const activeContract = CONTRACT_CONTENT[type] || {
    title: "Sözleşme Bulunamadı",
    content: <p className="text-muted">Aradığınız sözleşme metni mevcut değil.</p>
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div className="sozlesme-page-wrapper">
      <div className="sozlesme-bg-decoration">
        <div className="decor-circle circle-1"></div>
        <div className="decor-circle circle-2"></div>
      </div>

      <Container className="sozlesme-content-container">
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="sozlesme-header-section text-center mb-5">
              <h1 className="display-5 fw-black text-dark mb-3">Yasal Bilgilendirme</h1>
              <p className="text-muted lead">Tüm sözleşmelerimizi ve politikalarımızı buradan inceleyebilirsiniz.</p>
            </div>
          </Col>
        </Row>

        <Row className="gy-4">
          {/* SOL MENÜ - Masaüstünde daha şık bir görünüm */}
          <Col lg={4} xl={3}>
            <div className="sozlesme-sidebar sticky-top">
              <h5 className="sidebar-title">DOKÜMANLAR</h5>
              <div className="sidebar-nav">
                {Object.keys(CONTRACT_CONTENT).map((key) => (
                  <Link
                    key={key}
                    to={`/sozlesme/${key}`}
                    className={`nav-item-link ${type === key ? 'active' : ''}`}
                  >
                    <div className="nav-item-content">
                      <FileEarmarkText className="nav-icon" />
                      <span className="nav-text">{CONTRACT_CONTENT[key].title}</span>
                    </div>
                    {type === key && <ChevronRight className="nav-arrow" />}
                  </Link>
                ))}
              </div>

              <div className="sidebar-footer mt-4 p-3 bg-light rounded-4">
                <small className="text-muted d-block mb-2">Destek için:</small>
                <a href="mailto:staibilisim@gmail.com" className="text-primary fw-bold text-decoration-none small">
                  staibilisim@gmail.com
                </a>
              </div>
            </div>
          </Col>

          {/* SAĞ İÇERİK - Daha geniş ve ferah bir alan */}
          <Col lg={8} xl={9}>
            <div className="sozlesme-main-card">
              <div className="card-header-premium">
                <div className="header-icon-box">
                  <ShieldCheck size={28} />
                </div>
                <div>
                  <h2 className="m-0 fw-black text-dark">{activeContract.title}</h2>

                </div>
              </div>

              <div className="card-body-premium">
                <div className="contract-content-text">
                  {activeContract.content}
                </div>
              </div>

              <div className="card-footer-premium text-center border-top p-4">
                <p className="text-muted small mb-0">
                  Bu doküman <strong>STAİ BİLİŞİM A.Ş.</strong> tarafından hazırlanmıştır. Her hakkı saklıdır.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .sozlesme-page-wrapper {
          background-color: #fcfdfe;
          min-height: 100vh;
          padding: 80px 0;
          position: relative;
          overflow: hidden;
        }

        .sozlesme-bg-decoration {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
        }

        .decor-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.05;
        }

        .circle-1 {
          width: 400px;
          height: 400px;
          background: #0d6efd;
          top: -100px;
          right: -100px;
        }

        .circle-2 {
          width: 300px;
          height: 300px;
          background: #6f42c1;
          bottom: 100px;
          left: -50px;
        }

        .sozlesme-content-container {
          position: relative;
          z-index: 1;
        }

        .fw-black { font-weight: 900; }

        /* Sidebar Styles */
        .sozlesme-sidebar {
          top: 100px;
          background: white;
          padding: 25px;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.03);
          border: 1px solid #f1f5f9;
        }

        .sidebar-title {
          font-size: 0.75rem;
          font-weight: 800;
          color: #94a3b8;
          letter-spacing: 1.5px;
          margin-bottom: 20px;
          padding-left: 10px;
        }

        .sidebar-nav {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .nav-item-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 18px;
          border-radius: 14px;
          text-decoration: none;
          color: #475569;
          transition: 0.3s all ease;
          border: 1px solid transparent;
        }

        .nav-item-link:hover {
          background-color: #f8fafc;
          color: #0d6efd;
          transform: translateX(5px);
        }

        .nav-item-link.active {
          background-color: #f0f7ff;
          color: #0d6efd;
          border-color: #dbeafe;
          font-weight: 600;
        }

        .nav-item-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .nav-icon {
          font-size: 1.1rem;
          opacity: 0.7;
        }

        .nav-text {
          font-size: 0.95rem;
        }

        .nav-arrow {
          font-size: 0.8rem;
          opacity: 0.5;
        }

        /* Main Card Styles */
        .sozlesme-main-card {
          background: white;
          border-radius: 30px;
          box-shadow: 0 20px 50px rgba(0,0,0,0.04);
          border: 1px solid #f1f5f9;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .card-header-premium {
          padding: 40px 50px;
          border-bottom: 1px solid #f1f5f9;
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .header-icon-box {
          width: 60px;
          height: 60px;
          background: #f0f7ff;
          color: #0d6efd;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 18px;
        }

        .card-body-premium {
          padding: 50px;
          flex-grow: 1;
        }

        .contract-content-text {
          color: #334155;
          line-height: 1.8;
          font-size: 1.05rem;
          white-space: pre-line; /* Metin formatını korumak için */
        }

        .contract-content-text strong {
          color: #0f172a;
          font-weight: 700;
        }

        @media (max-width: 991px) {
          .sozlesme-page-wrapper { padding: 40px 0; }
          .card-header-premium { padding: 30px; }
          .card-body-premium { padding: 30px; }
          .sozlesme-sidebar { margin-bottom: 30px; position: static !important; }
        }
      `}</style>
    </div>
  );
};

export default Sozlesmeler;